export default class ProgressBar extends PIXI.Container {
    constructor(length) {
        super();

        this._tweens = new P3.utils.TWEEN.Group();

        this._index = 0;
        this._length = length;

        this._bg = new PIXI.Sprite(P3.assets.texture("panel_progress"));
        this._bg.anchor.set(0, 0.5);
        this._bg.position.set(-this._bg.width * 0.5, 0);
        this.addChild(this._bg);

        this._fill = new PIXI.Sprite(P3.assets.texture("progress_bar"));
        this._fill.anchor.set(0, 0.5);
        this._fill.position.set(-this._fill.width * 0.5 + 52, 76);
        this.addChild(this._fill);

        this._fillMask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fillMask.anchor.set(0, 0.5);
        this._fillMask.position.set(-this._fill.width * 0.5 + 52, this._fill.y);
        this._fillMask.width = 0;
        this._fillMask.height = this._fill.height;
        this.addChild(this._fillMask);

        this._fill.mask = this._fillMask;

    }

    update() {
        this._tweens.update();
    }

    updateFill(dir = 1) {
        this._index += dir > 0 ? 1 : -1;

        const targetWidth = this._fill.width * this._index / this._length;

        const a = new P3.utils.TWEEN.Tween(this._fillMask, this._tweens)
            .to({width: targetWidth}, 120);
        //  .start();

        const b = new P3.utils.TWEEN.Tween(this.scale, this._tweens)
            .to({x: 1.05, y: 1.05}, 60)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut);

        const c = new P3.utils.TWEEN.Tween(this.scale, this._tweens)
            .to({x: 1, y: 1}, 140)
            .easing(P3.utils.TWEEN.Easing.Back.In);

        a.chain(b);
        b.chain(c);
        a.start();
        //  .start();


    }
}